import { css } from "@emotion/react";

/**
 * ご訪問日時カレンダー
 ================================================== */
/** カレンダー */
export const calendarWrap = css`
  position: relative;
  min-width: 327px;
  width: 100%;
  background: var(--mtg-white);
  border-collapse: collapse;
  text-align: center;

  tr {
    border-right: 1px solid #ccc;
    :first-of-type {
      border-top: 1px solid #ccc;
    }

    th {
      padding: 6px;
    }

    td:first-of-type {
      font-size: 11px;
      padding: 10px 0;
      line-height: 8.8px;

      span:first-of-type {
        margin-bottom: 4px;
        display: block;
        line-height: 8.8px;
      }

      span:last-child {
        margin-top: 4px;
        display: block;
        line-height: 8.8px;
      }
    }

    td:not(:first-of-type) {
      input {
        display: none;
      }

      // :hasで対応したいが、FireFoxが非対応なので暫定処理（メモ）
      &.css-0:hover {
        background-color: var(--mtg-blue-4);
      }

      label {
        display: inline-block;
        line-height: 51px;
        width: 100%;
      }
    }
  }

  th,
  td {
    border-bottom: 1px solid #ccc;
    border-left: 1px solid #ccc;
  }

  th {
    font-size: 11px;
    font-weight: var(--mtg-body-w);
    width: 47px;
  }

  td {
    width: 41px;
    height: 51px;
  }

  button {
    font-size: 40px;
  }
`;

export const loadingCalendarWrap = css`
  position: relative;
  min-width: 327px;
  margin-bottom: 8px;
  width: 100%;
  background: var(--mtg-white);
  border-collapse: collapse;
  text-align: center;
`;

export const calendarArrow = css`
  display: block;
  margin: 0 auto;
  width: 0;
  height: 0;
  border-style: solid;
  border-right: 2px solid transparent;
  border-left: 2px solid transparent;
  border-top: 4px solid var(--mtg-grey-2);
  border-bottom: 0;
`;

export const doublecircleIcon = css`
  display: inline-block;
  width: 16px;
  height: 16px;
  text-align: center;
  border-radius: 50%;
  border: solid 1.5px var(--mtg-urbanblue);
`;

export const impossibleIcon = css`
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;

  ::before,
  ::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 2px;
    height: 16px;
    border-radius: 2px;
    background: var(--mtg-grey-1);
  }

  ::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  ::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`;

export const saturday = css`
  color: var(--mtg-skyblue);
`;

export const sunday = css`
  color: var(--mtg-live-red);
`;

export const weekDay = css`
  text-align: center;
  font-size: 11px;
  span {
    display: block;
  }
`;

export const calendarDisabled = css`
  background: var(--mtg-grey-4);
`;

export const calendarButton = css`
  width: 110px;
  height: 40px;
  background: var(--mtg-white);
  font-size: 12px;
  font-weight: 400;
  flex-direction: row;
  align-items: center;
  border: 1px solid var(--mtg-urbanblue);
  border-radius: 4px;

  :hover {
    background-color: var(--mtg-blue-4);
  }
`;

export const nextButton = css`
  float: right;
`;

export const telLink = css`
  a:visited {
    color: red;
  }
`;

/**
 * 機器の選択
 ================================================== */
export const uploadImgButton = css`
  display: block;
  margin: 0 auto 8px;
  width: 100%;
  height: 100px;
  border-radius: var(--mtg-border-radius);

  font-size: 12px;
  font-weight: 500;
  color: var(--mtg-urbanblue);

  border: 1px solid var(--mtg-urbanblue);
  background-color: var(--mtg-white);

  :hover {
    background-color: var(--mtg-blue-4);
  }
`;

export const uploadImg = css`
  vertical-align: top;
  object-fit: contain;
  width: 24px;
  height: 24px;
  margin-right: 4px;
`;

export const uploadText = css`
  display: block;
  font-weight: var(--mtg-caption-strong-w);
  font-size: var(--mtg-caption-strong-s);
  margin-top: 10px;
  line-height: 18.84px;
`;

export const hintText = css`
  display: flex;
  div:nth-of-type(3) {
    margin-left: 10px;
  }
`;

export const modalImgLineUp = css`
  display: flex;

  img:nth-of-type(1) {
    margin-right: 8px;
  }

  img {
    width: 50%;
  }
`;

/**
 * 確認画面
 ================================================== */
export const mtgConfText = css`
  margin-bottom: 12px;
  font-size: var(--mtg-body-s);
  font-weight: var(--mtg-body-w);
  line-height: 21.98px;
  word-wrap: break-word;
`;

export const mtgConfLabel = css`
  display: block;
  margin-bottom: 4px;
  font-size: var(--mtg-body-strong-s);
  font-weight: var(--mtg-body-strong-w);
  display: flex;
  justify-content: space-between;
`;

export const imgFlex = css`
  display: flex;
  justify-content: space-evenly;
`;

export const msgAccepted = css`
  padding: 15px;
  margin: 20px 0;
  font-size: var(--mtg-body-strong-s);
  color: var(--mtg-white);
  background: #c64e4e;
`;

/**
 * 完了画面
 ================================================== */
/** 受付 */
export const mtgWhiteBackgroundUktk = css`
  background-color: var(--mtg-white);
  padding: 24px 16px;
  border-radius: 8px;
  margin-bottom: 40px;
`;

export const uktkNm = css`
  position: relative;
  display: inline-block;
  font-size: var(--mtg-h3-s);
  font-weight: var(--mtg-h3-w);
  margin-bottom: var(--mtg-text-margin-h3);
  line-height: 25.2px;

  span {
    color: var(--mtg-urbanblue);
  }
`;

export const bunner = css`
  text-align: center;

  img {
    width: 327px;
  }
`;

/**
 * その他
 ================================================== */
export const none = css`
  display: none;
`;

export const whiteSpacePreWrap = css`
  white-space: pre-wrap;
`;

export const loadingCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.5);
`;

export const CalenderloadingCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.5);
`;
